export const GET_ALL_PLANS_SAGA = 'GET_ALL_PLANS_SAGA';
export const SET_PLANS = 'SET_PLANS';
